import React, { useContext, useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";

//axios and base url
import axios from "axios";
import { BASE_URL } from "../../../../../BaseUrl";

//functions
import {
  _t,
  getCookie,
  tableLoading,
  customStyle
} from "../../../../../functions/Functions";
import { useTranslation } from "react-i18next";

//3rd party packages
import { Helmet } from "react-helmet";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
//pages & includes
import ManageSidebar from "../ManageSidebar";

//context consumer
import { RestaurantContext } from "../../../../../contexts/Restaurant";
import { FoodContext } from "../../../../../contexts/Food";

const GiftHampersReturnAction = () => {
    const { t } = useTranslation();
    const history = useHistory();
    const {id} = useParams();
    //getting context values here
    let {
      loading,
      setLoading,
      branchForSearch,
    } = useContext(RestaurantContext);

    let { foodForPOS } = useContext(FoodContext)

    // States hook here
    //new item
    let [giftHampers, setGiftHampers] = useState({
      document_no: "",
      branch: null,      
      remarks: "",
      ref_doc: null,
      item: null,
      qty: 1,
      item_amount: 0,
      edit: false,
    });
    //new Row
    const [newRow,setNewRow]=useState([]);
    const [giftHampersRef, setGiftHampersRef] = useState([]);

    let common_toast = {
      position: "bottom-center",
      autoClose: 10000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      className: "text-center toast-notification",
    }

    //edit
    const handleEdit = async() =>{
      const url = BASE_URL + "/settings/gift-hamper-return/" + id;
        
      try {
        const res = await axios.get(url, {
        headers: { Authorization: `Bearer ${getCookie()}` },
        });   
        const date = new Date(res.data.document_date)
        setDocumentDate(date)
        setGiftHampers({
          document_no: res.data.document_identity,
          branch: res.data.branch,      
          remarks: res.data.remarks,
          ref_doc: { document_identity: res.data.ref_document_identity },
          item: res.data.item,
          qty: res.data.food_qty,
          item_amount: res.data,
          edit:true,
        });     
        const newRes = [];
        const detailsList = res.data.gift_hamper_return_details || [];
        detailsList && detailsList.forEach(item =>{
          const {qty, item_type, cost, ...rest}  = item;
          let itm = {
            item_name:{
              ...rest
            },
            cost: parseFloat(cost),
            qty: qty,
            stock_qty: item.stock_qty || 0,
            item_type: item_type,
        }
        newRes.push(itm)
        })
        setNewRow(newRes);
        setLoading(false);

      } catch (error) {              
        setLoading(false);
        toast.error(`${_t(t("Please try again later"))}`, common_toast);
      }
    }

    useEffect(()=>{
      if(id){
        handleEdit(id)
      }
    },[id]);
  
    //datepicker
    const [documentDate, setDocumentDate] = useState(new Date());

    const handleRefList = async (branch_id) => {
      const url = BASE_URL + "/settings/get-ghr-items/" + branch_id;
      try {
        setLoading(true)
        const res = await axios.get(url, {
          headers: { Authorization: `Bearer ${getCookie()}` },
        });
        if (res.data) {
          setNewRow([]);
          setLoading(false);
          setGiftHampersRef(res.data)
        }
        setLoading(false);
      } catch {
        setLoading(false);
      }
    }

    const handleSetRefNo = (data) => {
      if (data) {
        if (data?.gift_hamper_detail && data.gift_hamper_detail.length > 0) {
          let slugArr = [];
          data.gift_hamper_detail.map((item, index) => {
            const {qty, item_type, cost, ...rest}  = item;
            slugArr.push({
              id: index,
              item_name:{
                ...rest
              },
              cost: parseFloat(cost),
              stock_qty: item.stock_qty || 0, // default to large if stock not provided
              qty: qty,
              item_type: item_type || "food",
            })
          })
          setNewRow([...slugArr]);
        }
        // also set item and qty from the reference if they exist
        // const selectedItem = foodForPOS?.find(f => f.id === data.food_id) || { id: data.food_id, name: "Food Item" };
        setGiftHampers(prev => ({
          ...prev, 
          item: {
            id: data.food_id,
            name: data.food_name
          },
          qty: Number(data.pending_qty || 0),
          ref_doc: data,
        }))
      } else {
        setNewRow([]);
      }
    }

    //total qty
    const totalQty = () =>{
      const qty = newRow && newRow.reduce((acc,item) => {
        return acc + ((item.qty) ? parseInt(item.qty) : 0)
      },0);
      return qty;
    }

    //total amount
    const totalAmount = () =>{
      const total = newRow && newRow.reduce((acc,item) => {
        return acc + ((item.qty && giftHampers.qty) ? (parseInt(item.qty) * item.cost * Number(giftHampers.qty)) : 0)
      },0);
      return total.toFixed(2);
    }
  
    //total rate
    const totalRate = () =>{
      let total = totalAmount();
      return giftHampers.qty ? (Number(total)/parseFloat(giftHampers.qty)).toFixed(2) : total;
    }
  
    const totalItemQty = () =>{
      const qty = newRow && newRow.reduce((acc,item)=>{
        return acc + (item.qty && giftHampers.qty ? (parseInt(item.qty) * Number(giftHampers.qty)) : 0);
      },0);
      return qty;
    }
  
    //set each item qty
    const handleItemQty = (index,e) => {
      const newQty = Number(e.target.value)
      if(newQty <= newRow[index].stock_qty){
        newRow[index].qty = newQty;
        setNewRow([...newRow]);
      }else{
        toast.error(`${_t(t("Please select a quantity lower than stock quantity of this Branch"))}`, {
          position: "bottom-center",
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          className: "text-center toast-notification",
        });
      }  
    };

    //select food
    const handleSetItem = (item) => {
      setGiftHampers({ ...giftHampers, item });
    };

    //handle Set branch hook
    const handleSetBranch = (branch) => {
      setGiftHampers({ ...giftHampers, branch, ref_doc: null });
      setNewRow([]);
      if(branch && branch.id) {
          handleRefList(branch.id);
      }
    };
    
    const handleChange=(e)=>{
      if (e.target.name === "qty" && giftHampers.ref_doc) {
        let maxQty = giftHampers.ref_doc.pending_qty !== undefined ? giftHampers.ref_doc.pending_qty : giftHampers.ref_doc.food_qty;
        if (maxQty !== undefined && Number(e.target.value) > Number(maxQty)) {
          toast.error(`${_t(t("Quantity cannot be greater than pending quantity"))}`, common_toast);
          return;
        }
      }
      setGiftHampers({ ...giftHampers, [e.target.name]:e.target.value });
    }

    //post req edit item
    const FgGiftAxios = async () => {
      let date =
        new Date(documentDate).getFullYear() +
        "-" +
        (new Date(documentDate).getMonth() + 1) +
        "-" +
        new Date(documentDate).getDate();
  
      let slugArray=[];
      let duplicate = {};
      const duplicateItem = [];

      newRow.map((gift) => {
        const itemId = gift.item_type === "raw" ? "r" + gift.item_name.item_id : gift.item_name.item_id; 
        if(duplicate[itemId]){
          duplicateItem.push({
            item_id: gift.item_name.item_id,
            item_name: gift.item_name.item_name,  
          })
        }
        if(gift.item_name === ""){
          slugArray.push();
        }else{
          duplicate[itemId] = true;
          const totalQty = parseInt(gift.qty) * Number(giftHampers.qty);
          
          slugArray.push({
            gh_detail_id: gift.item_name?.gh_detail_id || null,
            qty: parseInt(gift.qty),
            item_type : gift.item_type,
            item_id: gift.item_name.item_id,
            item_name: gift.item_name.item_name,
            unit_name:  gift.item_name.unit_name || "Pcs",
            unit_id: gift.item_name.unit_id || 1, 
            item_code: gift.item_name?.item_code ?? "",
            cost: gift.cost.toFixed(3),
            cost_amount: (gift.cost * totalQty).toFixed(2),
            total_qty: (totalQty),
          });          
        }
      });

      if(duplicateItem?.length){
        toast.error(`${_t(t(`Duplicate item ${duplicateItem[0].item_name} found`))}`, common_toast);
        return;
      }
        
      if(newRow.length === slugArray.length){          
        setLoading(true);
      
        let formData = {
          ...((id && {id:id})),
          branch_id: giftHampers.branch.id,
          ref_document_identity: giftHampers.ref_doc?.document_identity || "",
          food_id: giftHampers.item.id, 
          food_qty: giftHampers.qty ? parseInt(giftHampers.qty) : 0,
          document_date: date,
          remarks: giftHampers.remarks,
          total_item_qty: totalQty(),
          total_consume_qty: totalItemQty(),
          items: slugArray,
          rate: totalRate(),
          amount: totalAmount(),
        };
        const method = giftHampers.edit && id ? "put" : "post";
        const endpoint =  giftHampers.edit && id ? "/settings/gift-hamper-return" : "/settings/gift-hamper-return";
        const url = BASE_URL + endpoint;
        
        try {
          const res = await axios[method](url, formData, {
          headers: { Authorization: `Bearer ${getCookie()}` },
          });        
          if(id){
            toast.success(`${_t(t("Gift Hampers Return has been updated"))}`,common_toast);
          }else{
            toast.success(`${_t(t("Gift Hampers Return has been added"))}`,common_toast);
          }
          setLoading(false);
          history.push("/dashboard/manage/stock/gift-hampers-return")
        } catch (error) {              
          setLoading(false);
          toast.error(`${_t(t("Please try again later"))}`, common_toast);
        }
      }else{
        toast.error(`${_t(t("Please select all dropdowns"))}`, common_toast);
      }
    };

      //send to server
      const handleSubmit = (e) => {
      e.preventDefault();
      if (
        giftHampers.branch !== null &&
        giftHampers.document_no !== null &&
        giftHampers.item !== null &&
        documentDate !== null
      ) {
        if(newRow.length > 0 && !isNaN(totalRate()) && !isNaN(totalAmount())){
            FgGiftAxios();
        }
        else{
          toast.error(`${_t(t("Please add gift hampers / rate or amount issue"))}`, common_toast);
        }
      } else {
        toast.error(`${_t(t("Please fill all the required fields"))}`,common_toast);
      }
    };
    
    return (
      <>
        <Helmet>
          <title>{_t(t("Gift Hampers Return"))}</title>
        </Helmet>
  
        {/* main body */}
        <main id="main" data-simplebar>
          <div className="container-fluid">
            <div className="row t-mt-10 gx-2">
              {/* left Sidebar */}
              <div className="col-lg-2 col-xxl-2 t-mb-30 mb-lg-0">
                <ManageSidebar />
              </div>
              {/* left Sidebar ends */}
  
              {/* Rightbar contents */}
              <div className="col-lg-10 col-xxl-10 t-mb-30 mb-lg-0">
                <div className="t-bg-white">
                  <div
                    className="fk-scroll--pos-menu table-bottom-info-hide"
                    data-simplebar
                  >
                    <div className="t-pl-15 t-pr-15">
                      <div className={`${loading && "loading"}`}></div>
                      {/* Loading effect */}
                      {/* {loading === true ? (
                        tableLoading()
                      ) : (
                      )} */}
                      <div key="smtp-form">
                        <div className="row gx-2 align-items-center t-pt-15 t-pb-15">
                          <div className="col-md-6 col-lg-5 t-mb-15 mb-md-0">
                            <ul className="t-list fk-breadcrumb">
                              <li className="fk-breadcrumb__list">
                                <span className="t-link fk-breadcrumb__link text-capitalize">
                                  {giftHampers.edit ? _t(t("Update Gift Hampers Return")) : _t(t("Add Gift Hampers Return"))}
                                </span>
                              </li>
                            </ul>
                          </div>
                          <div className="col-md-6 col-lg-7">
                            <div className="row gx-3 align-items-center"></div>
                          </div>
                        </div>

                        {/* Form starts here */}
                        <form
                          className="row card p-2 mx-3 mb-5 table-text"
                          onSubmit={(e) => handleSubmit(e)}
                          autoComplete="off"
                        >
                          <div className="col-12">
                            <div className="row">
                              <div className="form-group col-3 mt-3">
                                <div className="mb-2">
                                  <label
                                    htmlFor="document no"
                                    className="control-label"
                                  >
                                    {_t(t("Document no"))}
                                    <span className="text-danger">*</span>
                                  </label>
                                </div>
                                <div className="mb-2">
                                  <input
                                    readOnly
                                    type="text"
                                    className="form-control table-text"
                                    id="document_no"
                                    name="document_no"                                      
                                    placeholder="Auto no"
                                    required
                                  />
                                </div>
                              </div>

                              <div className="form-group col-3 text-right mt-3">
                                <div className="mb-2 text-left">
                                  <label
                                    htmlFor="transfer_date"
                                    className="control-label"
                                  >
                                    {_t(t("Document Date"))}
                                    <span className="text-danger">*</span>
                                  </label>
                                </div>
                                <div className="mb-2">
                                  <DatePicker
                                    selected={documentDate}
                                    onChange={(date) => setDocumentDate(date)}
                                    peekNextMonth
                                    showMonthDropdown
                                    showYearDropdown
                                    dropdownMode="select"
                                    className="form-control table-text"
                                    placeholderText={_t(t("Document date"))}
                                    shouldCloseOnSelect={false}
                                    disabled={!!id}
                                    required
                                  />
                                </div>
                              </div>
                              
                              <div className="form-group mt-3 col-3">
                                  <div className="mb-2">
                                    <label
                                      htmlFor="branch"
                                      className="control-label"
                                    >
                                      {_t(t("Branch"))}
                                      <span className="text-danger">*</span>                                        
                                    </label>
                                  </div>
                                  <Select
                                    options={branchForSearch ? branchForSearch : []}
                                    components={makeAnimated()}
                                    getOptionLabel={(option) => option.name}
                                    getOptionValue={(option) => option.id}
                                    value={giftHampers.branch || null}
                                    classNamePrefix="select"
                                    isDisabled={id}
                                    isClearable
                                    onChange={handleSetBranch}
                                    maxMenuHeight="200px"
                                    styles={customStyle}
                                    placeholder={
                                      _t(t("Please select a branch")) + ".."
                                    }
                                    required
                                  />
                              </div> 
                              
                              <div className="form-group mt-3 col-3">
                                <div className="mb-2">
                                  <label
                                    htmlFor="ref_no"
                                    className="control-label"
                                  >
                                    {_t(t("Ref No."))}
                                  </label>
                                </div>
                                <Select
                                  options={giftHampersRef ?? []}
                                  isDisabled={!giftHampers.branch || loading || id}
                                  components={makeAnimated()}
                                  getOptionLabel={(option) => option.document_identity}
                                  getOptionValue={(option) => option.id}
                                  value={giftHampers.ref_doc || ""}
                                  classNamePrefix="select"
                                  onChange={(data) => handleSetRefNo(data)}
                                  maxMenuHeight="200px"
                                  placeholder={
                                    _t(t("Please select ref")) + ".."
                                  }
                                  styles={customStyle}
                                  required
                                />
                              </div>

                            </div>

                            <div className="row">
                              <div className="form-group mt-2 col-3">
                              <div className="mb-2">
                                <label
                                  htmlFor="item"
                                  className="control-label"
                                >
                                  {_t(t("Select Item"))}
                                  <span className="text-danger">*</span> 
                                </label>
                              </div>
                              <div className="mb-2">
                                <Select
                                  options={foodForPOS ? foodForPOS : []}
                                  components={makeAnimated()}
                                  getOptionLabel={(option) => option.name}
                                  getOptionValue={(option) => option.id}
                                  value={giftHampers.item || null}
                                  isDisabled={true}
                                  classNamePrefix="select"
                                  isClearable
                                  onChange={handleSetItem}
                                  maxMenuHeight="200px"
                                  styles={customStyle}
                                  placeholder={
                                    _t(t("Please select a item")) + ".."
                                  }
                                />
                              </div>
                              </div> 
                              <div className="form-group mt-2 col-2">
                                <div className="mb-2">
                                  <label
                                    htmlFor="pending_qty"
                                    className="control-label"
                                  >
                                    {_t(t("Pending Qty"))}
                                  </label>
                                </div>
                                <div className="mb-2">
                                  <input
                                    type="number"
                                    className="form-control"
                                    id="pending_qty"
                                    name="pending_qty"
                                    value={giftHampers.ref_doc?.pending_qty !== undefined ? giftHampers.ref_doc?.pending_qty : (giftHampers.ref_doc?.food_qty || "")}
                                    placeholder="Pending"
                                    readOnly
                                  />
                                </div>
                              </div> 
                              <div className="form-group mt-2 col-2">
                                <div className="mb-2">
                                  <label
                                    htmlFor="item_qty"
                                    className="control-label"
                                  >
                                    {_t(t("Qty"))}
                                    <span className="text-danger">*</span> 
                                  </label>
                                </div>
                                <div className="mb-2">
                                  <input
                                  type="number"
                                  min="1"
                                  onKeyDown={(evt) =>
                                      ["e", "E", "+", "-","ArrowUp","ArrowDown"].includes(evt.key) &&
                                      evt.preventDefault()
                                    }
                                    onWheel={(e) => e.target.blur()}
                                    className="form-control"
                                    id="item_qty"
                                    name="qty"
                                    onChange={handleChange}
                                    value={giftHampers.qty || ""}
                                    placeholder="Item Qty"
                                    required          
                                  />
                                </div>
                              </div>  
                              <div className="form-group mt-2 col-2">
                              <div className="mb-2">
                                <label
                                  htmlFor="rate"
                                  className="control-label"
                                >
                                  {_t(t("Rate Per Unit"))}
                                  <span className="text-danger">*</span> 
                                </label>
                              </div>
                              <div className="mb-2">
                                <input
                                  type="number"
                                  className="form-control"
                                  id="rate"
                                  name="rate"
                                  value={totalRate()}
                                  placeholder="Rate"
                                  readOnly          
                                />
                              </div>
                              </div>  
                              <div className="form-group mt-2 col-3">
                              <div className="mb-2">
                                <label
                                  htmlFor="amount"
                                  className="control-label"
                                >
                                  {_t(t("Amount"))}
                                  <span className="text-danger">*</span> 
                                </label>
                              </div>
                              <div className="mb-2">
                                <input
                                  type="number"
                                  className="form-control"
                                  id="amount"
                                  name="amount"
                                  value={totalAmount()}
                                  placeholder="Amount"
                                  readOnly          
                                />
                              </div>
                              </div>                                                         
                             </div>

                             <div className="row">
                              <div className="form-group mt-2 col-12">
                                <div className="mb-2">
                                  <label
                                    htmlFor="remarks"
                                    className="control-label"
                                  >
                                    {_t(t("Remarks"))}
                                  </label>
                                </div>
                                <div className="mb-2">
                                  <textarea
                                    type="text"
                                    className="form-control table-text"
                                    id="remarks"
                                    name="remarks"
                                    onChange={handleChange}
                                    value={giftHampers.remarks || ""}
                                    placeholder="Remarks"
                                    rows="1"
                                  />
                                </div>
                              </div>
                             </div>                            
                              
                            <div className={`table-responsive mt-3 pr-1 `}
                              style={{maxHeight:"23rem",overflow: "auto"}}>
                                <table className="table table-bordered-sm table-hover">
                                  <thead className="align-middle">                                    
                                    <tr>
                                      <th
                                        scope="col"
                                        className="table-text text-capitalize align-middle text-center border-1 border"
                                        style={{width:"20rem"}}
                                      >
                                        <span style={{fontWeight:500}}>
                                        {_t(t("Type"))}
                                        </span>
                                      </th>  
                                      <th
                                        scope="col"
                                        className="table-text text-capitalize align-middle text-center border-1 border"
                                        style={{width:"32rem"}}
                                      >
                                        <span style={{fontWeight:500}}>
                                        {_t(t("Item Name"))}
                                        </span>
                                      </th>                                     
                                      
                                      <th
                                        scope="col"
                                        className="table-text text-capitalize align-middle text-center border-1 border"
                                        style={{width:"18rem"}}
                                      >
                                        <span style={{fontWeight:500}}>
                                        {_t(t("Qty"))}
                                        </span>
                                      </th>

                                      <th
                                        scope="col"
                                        className="table-text text-capitalize align-middle text-center border-1 border"
                                        style={{width:"18rem"}}
                                      >
                                        <span style={{fontWeight:500}}>
                                        {_t(t("Cost"))}
                                        </span>
                                      </th>

                                      <th
                                        scope="col"
                                        className="table-text text-capitalize align-middle text-center border-1 border"
                                        style={{width:"18rem"}}
                                      >
                                          <span style={{fontWeight:500}}>
                                          {_t(t("Total Qty"))}
                                          </span>
                                      </th>

                                      <th
                                        scope="col"
                                        className="table-text text-capitalize align-middle text-center border-1 border"
                                        style={{width:"18rem"}}
                                      >
                                        <span style={{fontWeight:500}}>
                                        {_t(t("Amount"))}
                                        </span>
                                      </th>

                                    </tr>
                                  </thead>
                                  {newRow && newRow.length > 0 ?
                                    <tbody className="align-middle">
                                      {newRow.map((gifts, index) => {
                                          return (
                                            <tr
                                              className="align-middle"
                                              key={index}
                                            >
                                              <td className="table-text text-capitalize align-middle text-center" style={{height:"4rem"}}>
                                                {gifts.item_type === "food" ? "Food" : "Raw"}
                                              </td>

                                              <td className="table-text text-capitalize align-middle text-center">
                                                {gifts.item_name.item_name || gifts.item_name.name}
                                              </td>                                              

                                              <td className="table-text text-capitalize align-middle text-center">
                                                <input
                                                  type="number"
                                                  step={gifts.item_type === "food" ? "1" : "0.1"}
                                                  min="1"
                                                  onKeyDown={(evt) =>
                                                    ["e", "E", "+", "-","ArrowUp","ArrowDown"].includes(evt.key) &&
                                                    evt.preventDefault()
                                                  }
                                                  onWheel={(e) => e.target.blur()}
                                                  className="form-control text-center table-Input table-text"
                                                  id={gifts.item_name.item_id}
                                                  name={gifts.item_name.item_id}
                                                  onChange={(e)=>handleItemQty(index,e)}
                                                  value={gifts.qty || ""}
                                                  placeholder="Qty"
                                                  readOnly                                                  
                                                />
                                              </td>

                                              <td className="table-text text-capitalize align-middle text-center">
                                                <input
                                                  type="number"
                                                  step="0.1"
                                                  min="0"
                                                  className="form-control text-center table-Input table-text"
                                                  id={gifts.item_name.item_id}
                                                  name={gifts.item_name.item_id}
                                                  value={gifts.cost?.toFixed(3) || 0}
                                                  readOnly                                                  
                                                />
                                              </td>

                                              <td className="table-text text-capitalize align-middle text-center">
                                                <input
                                                  type="number"
                                                  step="0.1"
                                                  min="0"
                                                  className="form-control text-center table-Input table-text"
                                                  id={gifts.item_name.item_id}
                                                  name={gifts.item_name.item_id}
                                                  value={gifts.qty && giftHampers.qty ? (parseInt(gifts.qty) * Number(giftHampers.qty)) : 0}
                                                  readOnly                                                  
                                                />
                                              </td>
                                              <td className="table-text text-capitalize align-middle text-center">
                                                <input
                                                  type="number"
                                                  step="0.1"
                                                  min="0"
                                                  className="form-control text-center table-Input table-text"
                                                  id={gifts.item_name.item_id}
                                                  name={gifts.item_name.item_id}
                                                  value={gifts.qty && giftHampers.qty ? (parseInt(gifts.qty) * gifts.cost * Number(giftHampers.qty)).toFixed(2) : 0}
                                                  readOnly                                                  
                                                />
                                              </td>
                                              
                                            </tr>
                                          );
                                        }
                                      )}
                                      <tr>
                                      <th></th>
                                      <th className="text-capitalize align-middle text-center">Total</th>
                                      <th className="text-capitalize align-middle text-center">{totalQty()}</th>
                                      <th></th>
                                      <th className="text-capitalize align-middle text-center">{totalItemQty()}</th>
                                      <th className="text-capitalize align-middle text-center">{totalAmount()}</th>
                                      </tr>
                                    </tbody>
                                  : null}
                                </table>
                              </div>                                

                            <div className="form-group mt-4 pb-2">                                
                              <div className="d-flex justify-content-end align-items-center">
                                <div className="col-3 d-flex justify-content-end">
                                  <button
                                    type="button"
                                    className="btn rounded hov-btn mr-3"
                                    onClick={()=>(history.push("/dashboard/manage/stock/gift-hampers-return"))}                                
                                  >
                                    <i className="fa fa-arrow-left" aria-hidden="true"></i> {_t(t("Back"))}
                                  </button>
                                  <button
                                    disabled={loading}
                                    type="submit"
                                    className="btn btn-primary rounded"
                                  >
                                    <i className="fa fa-floppy-o" aria-hidden="true"></i> {giftHampers.edit ? _t(t("Update")) : _t(t("Save"))}
                                  </button>                                                    
                                </div>                                                    
                              </div>
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* Rightbar contents end*/}
            </div>
          </div>
        </main>
        {/* main body ends */}
      </>
    );
}

export default GiftHampersReturnAction;
